export const notificationRoutes = {
  initializeDevice: 'notification/init-device-endpoint',
} as const;
